import { render, staticRenderFns } from "./InvoiceType.vue?vue&type=template&id=cbdb60a2&scoped=true&"
import script from "./InvoiceType.vue?vue&type=script&lang=js&"
export * from "./InvoiceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdb60a2",
  null
  
)

export default component.exports